class Logger {
  private isProduction = process.env.NEXT_PUBLIC_NODE_ENV === 'production';

  log(message: string, ...args: any[]) {
    if (!this.isProduction) {
      console.log(message, ...args);
    }
  }

  error(message: string, error?: any) {
    if (!this.isProduction) {
      console.error(message, error);
    }
  }

  warn(message: string, ...args: any[]) {
    if (!this.isProduction) {
      console.warn(message, ...args);
    }
  }

  debug(message: string, ...args: any[]) {
    if (!this.isProduction) {
      console.debug(message, ...args);
    }
  }
}

export const logger = new Logger();